import { FadeIn } from "../motion/Reveal";
import { SectionLabel } from "../motion/SectionLabel";
import { APPROACH, GEN } from "../../data/content";

export const Approach = () => {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="max-w-4xl mb-20">
          <SectionLabel>{APPROACH.label}</SectionLabel>
          <FadeIn delay={0.1}>
            <h2 className="mt-6 font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              {APPROACH.heading}
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="mt-8 font-body text-xl text-white leading-relaxed font-light">
              {APPROACH.lead}
            </p>
          </FadeIn>
          <FadeIn delay={0.3}>
            <p className="mt-5 font-body text-lg text-neutral-400 leading-relaxed font-light max-w-2xl">
              {APPROACH.body}
            </p>
          </FadeIn>
        </div>

        <FadeIn className="mb-20 group relative overflow-hidden rounded-3xl border border-white/10 h-[38vh] md:h-[52vh]">
          <img
            src={GEN.approach}
            alt=""
            aria-hidden
            className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <FadeIn delay={0.1} className="lg:col-span-7">
            <blockquote>
              <p className="font-display font-bold text-white text-3xl md:text-5xl leading-[1.1] tracking-tight">
                {APPROACH.pull}
              </p>
            </blockquote>
          </FadeIn>
          <FadeIn delay={0.2} className="lg:col-span-4 lg:col-start-9 flex items-center">
            <div className="h-px w-full bg-gradient-to-r from-[#ff4500] to-transparent" />
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
